'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');
var title = 'Invest Your Values';
var description = 'See how 401(k)s or similar employee retirement plans of S&P 500 companies are rated on environmental and social sustainability issues.';
var domain = process.env.DOMAIN || 'https://investyourvalues.org';
// if were not the client (window) use the injected config otherwise create it
var Version = require('./data/Version.json');
var FundCategoryAll = require('./data/FundCategoryAll.json');
var FundFamilyAll = require('./data/FundFamilyAll.json');
var CoreBenchmarks = require('./data/CoreBenchmarks.json');
var ExtendedBenchmarks = require('./data/ExtendedBenchmarks.json');
var FamilyFunds = require('./data/FamilyFunds.json');
var TargetDateSeries = require('./data/TargetDateSeries.json');
var PlansSource = require('./data/Plans.json');
var PlanOptionsSource = require('./data/PlanOptions.json');
// bonds 202211
var TargetDateBondsSource = require('./data/TdFundsBonds.json');
var PlansBondsSource = require('./data/PlansBonds.json');
var PlanOptionsBondsSource = require('./data/PlanOptionsBonds.json');
//
var PffCompanyProfiles = require('./data/PffCompanyProfiles.json');
var WffCompanySources = require('./data/WffCompanySources.json');
var WffSources = require('./data/WffSources.json');
var DffCompanySectors = require('./data/DffCompanySectors.json');
var DffCompanyLinks = require('./data/DffCompanyLinks.json');
var DffCompanyProfiles = require('./data/DffCompanyProfiles.json');
//
var config = {
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  version: Version['version'],
  versionDate: Version['version_date'],
  description: description,
  domain: domain,
  loggingOff: process.env.LOGGING_OFF,
  httpsRedirect: process.env.HTTPS_REDIRECT,
  gaKey: process.env.GA_KEY,
  gtmId: process.env.GTM_ID,
  linkedinPid: process.env.LINKEDIN_PID,
  fbPixelId: process.env.FB_PIXEL_ID,
  apiHost: process.env.APIHOST || 'https://api.fossilfreefunds.org',
  apiPort: process.env.APIPORT || 443,
  queryMaxFunds: 10,
  socialAppId: '1094061130685792',
  shareMessage: title,
  coreBenchmarks: CoreBenchmarks,
  extendedBenchmarks: ExtendedBenchmarks,
  plansSource: PlansSource,
  planOptionsSource: PlanOptionsSource,
  familyFunds: FamilyFunds,
  targetDateSeries: TargetDateSeries,
  // bonds 202211
  plansBondsSource: PlansBondsSource,
  planOptionsBondsSource: PlanOptionsBondsSource,
  targetDateBondsSource: TargetDateBondsSource,
  //
  dffCompanySectors: DffCompanySectors,
  dffCompanyLinks: DffCompanyLinks,
  dffCompanyProfiles: DffCompanyProfiles,
  pffCompanyProfiles: PffCompanyProfiles,
  wffCompanySources: WffCompanySources,
  wffSources: WffSources,
  //
  profilePath: 'scorecard',
  companyVideoIds: {
    'Apple': '659076045'
  },
  signupForm: {
    url: 'https://go.asyousow.org/l/344561/2020-08-12/tc67kw',
    id: '344561_92350pi_344561_92350'
  },
  amznSignupForm: {
    url: 'https://go.asyousow.org/l/344561/2021-08-04/23m5w7y',
    id: '344561_121640pi_344561_121640'
  },
  petitionConfigs: {
    amazonVanguard: {
      companyName: 'Amazon',
      petitionName: 'vanguard_petition',
      linkedinTrackingId: '4984530',
      pardotFormUrl: 'https://go.asyousow.org/l/344561/2021-08-27/23z97wr',
      pardotFirstNameId: '344561_123602pi_344561_123602',
      pardotLastNameId: '344561_123604pi_344561_123604',
      pardotEmailId: '344561_123600pi_344561_123600'
    },
    comcast: {
      companyName: 'Comcast',
      petitionName: 'comcast_petition',
      linkedinTrackingId: '5083450',
      pardotFormUrl: 'https://go.asyousow.org/l/344561/2021-09-23/24k6bz4',
      pardotFirstNameId: '344561_126233pi_344561_126233',
      pardotLastNameId: '344561_126235pi_344561_126235',
      pardotEmailId: '344561_126237pi_344561_126237'
    }
  },
  routes: {
    notFound: '/not-found-404',
    home: '/',
    // issue pages
    issues: '/the-issues',
    issueFossilFuels: '/the-issues/fossil-fuels',
    issueFossilFuelFinanceInsurance: '/the-issues/fossil-fuel-finance-insurance',
    issueDeforestation: '/the-issues/deforestation',
    issueGenderEquality: '/the-issues/gender-equality',
    issueCivilianFirearms: '/the-issues/civilian-firearms',
    issuePrisonIndustrialComplex: '/the-issues/prison-industrial-complex',
    issueArmsManufacturers: '/the-issues/arms-manufacturers',
    issueTobacco: '/the-issues/tobacco',
    // solution pages
    solutions: '/the-solutions',
    solutionOfferSustainability: '/the-solutions/offer-sustainability',
    solutionDefaultSustainability: '/the-solutions/default-sustainability',
    // dynamic lists
    data: '/the-data',
    plans: '/retirement-plans',
    assetManagers: '/asset-managers',
    targetDateFunds: '/target-date-funds',
    mutualFundsETFs: '/mutual-funds-etfs',
    list: '/mutual-funds-etfs',
    clean: '/mutual-funds-etfs',
    compare: '/compare',
    fund: '/mutual-funds-etfs',
    companies: '/companies',
    company: '/companies',
    howitworks: '/methodology',
    methodology: '/methodology',
    // educenter
    eduCenter: '/action-center',
    eduCenterFinRisks: '/action-center/financial-risks',
    eduCenterIndividual: '/action-center/employees',
    eduCenterPlanAdmins: '/action-center/plan-administrators',
    faqs: '/action-center/faqs',
    // misc pages
    about: '/about',
    legal: '/legal',
    // amazon ad campaign 2021
    amazonStaffLanding: '/amazon',
    amazonStaffThanks: '/amazon-thanks',
    amazonVanguardLanding: '/amazon-vanguard',
    amazonVanguardThanks: '/amazon-vanguard-thanks',
    // comcast ad campaign 2021
    comcastPetitionLanding: '/comcast',
    comcastPetitionThanks: '/comcast-thanks',
    // AGM ad campaigns 2022
    resolutionLanding: '/shareholder-resolution',
    // bonds
    fossilFuelBondsIn401ks: '/fossil-fuel-bonds-in-401ks',
    fossilFuelBondRisks: '/financial-risks-fossil-fuel-bonds'
  },
  links: {
    exclusionListsS3: 'https://iyv-charts.s3.us-west-2.amazonaws.com/exclusion-lists/',
    donate: 'https://connect.clickandpledge.com/w/Form/9d5e83e2-b2d9-43eb-9834-043d7558b785',
    contact: 'https://www.asyousow.org/contact',
    signup: 'https://go.asyousow.org/sign-up-invest-your-values',
    ays: 'http://www.asyousow.org',
    aysabout: 'http://www.asyousow.org/about-us',
    ceres: 'http://www.ceres.org/investor-network/resolutions#!/subject=&year=&company=&filer=&sector=&status=&memo=&all=&=',
    fff: 'https://fossilfreefunds.org',
    dff: 'https://deforestationfreefunds.org',
    gef: 'https://genderequalityfunds.org',
    wff: 'https://weaponfreefunds.org',
    gff: 'https://gunfreefunds.org',
    tff: 'https://tobaccofreefunds.org',
    pff: 'https://prisonfreefunds.org',
    equileap: 'httpsRedirect://equileap.org/',
    aysinvest: 'https://www.asyousow.org/invest-your-values/',
    fffClean: 'https://fossilfreefunds.org/funds?dsc=false&srt=c2f5coogutweight',
    aysvoteshares: 'http://www.asyousow.org/about-us/vote-your-shares/',
    pledge: 'http://www.divestfromwarmachine.org/take_the_pledge',
    dfw: 'http://www.divestfromwarmachine.org/',
    codepink: 'https://www.codepink.org/',
    morningstar: 'https://www.morningstar.com/',
    socialAYSfb: 'https://www.facebook.com/asyousow.org/',
    socialAYStwitter: 'https://twitter.com/asyousow',
    socialAYSinstagram: 'https://www.instagram.com/_asyousow_/',
    ussifperf: 'https://www.ussif.org/performance',
    ussif: 'https://www.ussif.org/',
    dontbank: 'https://www.dontbankonthebomb.com/',
    dfwguides: 'http://www.divestfromwarmachine.org/guides',
    afscInvestigate: 'https://investigate.afsc.org/',
    paxClusterMunitions: 'https://paxforpeace.nl/media/download/pax-worldwide-investment-in-cluster-munitions-2018pdf.pdf',
    paxNuclearWeapons: 'https://www.dontbankonthebomb.com/risky-returns/',
    dol5500search: 'https://www.efast.dol.gov/5500Search/',
    iyvSpreadsheet: 'https://www.asyousow.org/invest-your-values/download-data',
    morningstarFff: 'https://fossilfreefunds.org/morningstar',
    fficu200: 'https://www.ffisolutions.com/research-analytics-index-solutions/research-screening/the-carbon-underground-200/',
    gcel: 'https://coalexit.org/',
    gogel: 'https://gogel.org/',
    macroclimate50: 'https://fossilfreefunds.org/macroclimate-30',
    clean200Fff: 'https://fossilfreefunds.org/clean-200',
    proxyvote: 'https://central.proxyvote.com/pv/web'
  },
  chartOptions: {
    animation: false,
    segmentStrokeWidth: 0,
    percentageInnerCutout: 60,
    showTooltips: false
  },
  formOptions: {
    market: [{ name: 'All funds', value: 'Show all funds' }, { name: 'United States', value: 'US' }],
    type: [{ name: 'All funds', value: 'All funds' }, { name: 'Open-end funds', value: 'FO' }, { name: 'Exchange-traded funds (ETFs)', value: 'FE' }, { name: 'Common/Collective trusts', value: 'TSP' }, { name: 'Variable annuities', value: 'VA' }],
    diversified: [{ name: 'All funds', value: false }, { name: 'Diversified', value: 'false' }, { name: 'Non-diversified', value: 'true' }],
    sri: [{ name: 'All funds', value: false }, { name: 'Sustainability mandate', value: '1' }],
    fundUssif: [{ name: 'All funds', value: false }, { name: 'US-SIF funds', value: '1.5' }],
    targetDate: [{ name: 'All funds', value: false }, { name: 'Target date funds', value: '1' }],
    fundPerformance: [{ name: 'All funds', value: false }, { name: 'Positive 1-year returns', value: 'trailing_return_y1' }, { name: 'Positive 3-year returns', value: 'trailing_return_y3' }, { name: 'Positive 5-year returns', value: 'trailing_return_y5' }, { name: 'Positive 10-year returns', value: 'trailing_return_y10' }, { name: 'Positive 15-year returns', value: 'trailing_return_y15' }, { name: 'Positive 20-year returns', value: 'trailing_return_y20' }],
    fffGrade: [{ name: 'All funds', value: false }, { name: 'Fossil fuel grade A', value: 1 }, { name: 'Fossil fuel grade B or higher', value: 2 }, { name: 'Fossil fuel grade C or higher', value: 3 }, { name: 'Fossil fuel grade D or higher', value: 4 }],
    ffbGrade: [{ name: 'All funds', value: false }, { name: 'Fossil finance grade A', value: 1 }, { name: 'Fossil finance grade B or higher', value: 2 }, { name: 'Fossil finance grade C or higher', value: 3 }, { name: 'Fossil finance grade D or higher', value: 4 }],
    ffiGrade: [{ name: 'All funds', value: false }, { name: 'Fossil insurance grade A', value: 1 }, { name: 'Fossil insurance grade B or higher', value: 2 }, { name: 'Fossil insurance grade C or higher', value: 3 }, { name: 'Fossil insurance grade D or higher', value: 4 }],
    dffGrade: [{ name: 'All funds', value: false }, { name: 'Deforestation grade A', value: 1 }, { name: 'Deforestation grade Engagement or higher', value: 1.5 }, { name: 'Deforestation grade B or higher', value: 2 }, { name: 'Deforestation grade C or higher', value: 3 }, { name: 'Deforestation grade D or higher', value: 4 }],
    gefGrade: [{ name: 'All funds', value: false }, { name: 'Gender equality grade A', value: 1 }, { name: 'Gender equality grade B or higher', value: 2 }, { name: 'Gender equality grade C or higher', value: 3 }, { name: 'Gender equality grade D or higher', value: 4 }],
    wffGrade: [{ name: 'All funds', value: false }, { name: 'Weapon grade A', value: 1 }, { name: 'Weapon grade B or higher', value: 2 }, { name: 'Weapon grade C or higher', value: 3 }, { name: 'Weapon grade D or higher', value: 4 }],
    gffGrade: [{ name: 'All funds', value: false }, { name: 'Civilian firearm grade A', value: 1 }, { name: 'Civilian firearm grade B or higher', value: 2 }, { name: 'Civilian firearm grade C or higher', value: 3 }, { name: 'Civilian firearm grade D or higher', value: 4 }],
    tffGrade: [{ name: 'All funds', value: false }, { name: 'Tobacco grade A', value: 1 }, { name: 'Tobacco grade Engagement or higher', value: 1.5 }, { name: 'Tobacco grade B or higher', value: 2 }, { name: 'Tobacco grade C or higher', value: 3 }, { name: 'Tobacco grade D or higher', value: 4 }],
    pffGrade: [{ name: 'All funds', value: false }, { name: 'Prison industrial complex grade A', value: 1 }, { name: 'Prison industrial complex grade B or higher', value: 2 }, { name: 'Prison industrial complex grade C or higher', value: 3 }, { name: 'Prison industrial complex grade D or higher', value: 4 }],
    clean: [{ name: 'All funds', value: false }, { name: 'A grade funds only', value: 'true' }],
    currency: [],
    currencyAll: [{ name: 'All funds' }, { name: 'US Dollar' }],
    currencyUS: [],
    currencyUK: [],
    currencyHK: [],
    currencyDK: [],
    currencyFR: [],
    currencyDE: [],
    fundGroup: [],
    fundGroupAll: [{ name: 'All funds' }, { name: 'Allocation Funds' }, { name: 'International Equity Funds' }, { name: 'Sector Equity Funds' }, { name: 'U.S. Equity Fund' }],
    fundGroupUS: [],
    fundGroupUK: [],
    fundGroupHK: [],
    fundGroupDK: [],
    fundGroupFR: [],
    fundGroupDE: [],
    fundCategory: [],
    fundCategoryAll: FundCategoryAll,
    fundCategoryUS: [],
    fundCategoryUK: [],
    fundCategoryHK: [],
    fundCategoryDK: [],
    fundCategoryFR: [],
    fundCategoryDE: [],
    fundFamily: [],
    fundFamilyAll: FundFamilyAll,
    fundFamilyUS: [],
    fundFamilyUK: [],
    fundFamilyHK: [],
    fundFamilyDK: [],
    fundFamilyFR: [],
    fundFamilyDE: []
  },
  app: {
    title: title,
    description: description,
    head: {
      defaultTitle: title,
      titleTemplate: '%s - ' + title,
      meta: [{ name: 'description', content: description }, { charset: 'utf-8' },
      // twitter
      { property: 'twitter:card', content: 'summary_large_image' }, { property: 'twitter:site', content: '@asyousow' }, { property: 'twitter:title', content: title }, { property: 'twitter:description', content: description }, { property: 'twitter:creator', content: '@asyousow' }, { property: 'twitter:image', content: '' },
      // {property: 'twitter:image', content: ''},

      // og
      { property: 'og:site_name', content: title }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: domain }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: '' }]
    }
  }
};
// inject the serverconfig if its on the browser
if (typeof window !== 'undefined') {
  config = (0, _assign2.default)({}, config, window.__serverConfig);
}
module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 9
// module chunks = 0